<div class="modal-content">
  <div class="modal-header">
    <span id="addPageModalTitleId"
      >{{ verb }}
      <span [ngSwitch]="container.type"
        ><span *ngSwitchCase="1">Page</span
        ><span *ngSwitchDefault>Section</span></span
      >
    </span>
    <i class="material-icons" data-bs-dismiss="modal" (click)="closeAddPageModal()"
      >close</i
    >
  </div>
  <div class="modal-body">
    <form [formGroup]="addEditPageForm">
      <div>
        <div class="form-group row align-items-center">
          <label class="col-sm-3 control-label" for="Title">Title</label>
          <div class="col-sm-9">
            <input
              type="text"
              formControlName="Title"
              class="form-control vplaybook__form__inputs"
              (keyup.enter)="addEditPage()"
            />
          </div>
        </div>
        <div *ngIf="languageId == defaultLanguageId">
          <div
            *ngIf="container.type == 2"
            class="form-group row align-items-center"
          >
            <label class="control-label col-sm-3" for="isShaded"
              >Shade Section</label
            >
            <div class="col-sm-4">
              <div class="btn-group btn__sm">
                <label class="switch">
                  <input
                    type="checkbox"
                    [checked]="container.isShaded"
                    (change)="container.isShaded = !container.isShaded"
                  />
                  <span class="slider vPlaybookActiveToggle round"></span>
                </label>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              container.parentContainerId == null &&
              container.type == 1 &&
              !customIconArray.length
            "
            class="form-group row mb-0"
          >
            <img
              class="sprite-image"
              src="/assets/img/dsg-page-icons-sprite.png"
              style="display: none"
            />
            <ul #iconList class="icon-gallery col-sm-12">
              <li
                class="col-sm-3 control-label pt-0 field_name"
                style="display: inline-block"
              >
                Icon
              </li>
              <li class="col-sm-9" style="display: inline-block">
                <ng-container *ngFor="let ci of iconArray">
                  <a
                    id="addPageIconArrayId"
                    (click)="setIcon(ci)"
                    href="javascript:void(0);"
                    [ngClass]="{ selected: container.iconClass == ci }"
                    class="page-icon-{{ ci }} iconpicker "
                  ></a>
                </ng-container>
              </li>
              <li style="clear: both"></li>
            </ul>
          </div>
          <!-- inline-label -->

          <div
            *ngIf="customIconArray.length"
            class="form-group row align-items-center mb-0"
          >
            <label class="control-label col-sm-3">Icon</label>
            <ng-scrollbar class="sidebar-scroll col-sm-9" track="vertical">
              <ul class="custom-icons">
                <li
                  *ngFor="let icon of customIconArray"
                  (click)="selectCustomIcon(icon)"
                  [ngClass]="{
                    selected: container.customIconAssetId == icon.assetId
                  }"
                >
                  <img
                    [src]="
                      '/api/Assets/Image/' + icon.assetId + '?height=25'
                        | loadSecureAssets : true
                        | async
                    "
                  />
                </li>
              </ul>
            </ng-scrollbar>
          </div>

          <div class="form-group row mb-2" *ngIf="container.type == 2">
            <label class="control-label col-sm-3 pt-0">Image</label>
            <div class="upload-image col-sm-8">
              <a
                class="remove-placeholder-image"
                (click)="removeImage(true)"
                *ngIf="container.previewImageId"
              >
                <i class="material-icons pointer" aria-hidden="true">delete</i>
              </a>
              <div (click)="openFileDialog(true)" class="upload-image-file">
                <div
                  *ngIf="
                    !uploadedImage && !container.previewImageId;
                    else imgselected
                  "
                  class="upload-box pointer"
                  title="click to change file"
                >
                  <span class="material-icons upload-icon upload-icon-color"
                    >cloud_upload</span
                  >
                </div>
                <ng-template #imgselected>
                  <img
                    id="imgBackground"
                    title="click to change file"
                    [ngStyle]="{
                      width:
                        uploadedImage || container.previewImageId
                          ? 'auto'
                          : '100%',
                      height:
                        uploadedImage || container.previewImageId
                          ? '115px'
                          : '24px'
                    }"
                    class="upload-box pointer"
                    [src]="getImageSrc() | loadSecureAssets : true | async"
                    alt=""
                    onerror="this.src = 'assets/img/loader.gif'"
                    (load)="imageLoadedPages = true"
                    [hidden]="!imageLoadedPages"
                  />
                </ng-template>
                <div class="file-upload hide">
                  <input
                    id="uploadImage"
                    #fileInput
                    (click)="fileInput.value = null"
                    (change)="imageSelected($event, true)"
                    accept="image/jpg, image/jpeg, image/png"
                    class="file-upload__input"
                    type="file"
                    name="preview-file-upload"
                  />
                </div>
                <div id="transparent-uploadifive-queue"></div>
              </div>
              <div class="row" *ngIf="showProgress">
                <div class="col-sm-12">
                  <section
                    class="modal-pop"
                    *ngIf="showProgress"
                    style="position: relative !important"
                  >
                    <div class="progress progress-striped active">
                      <div
                        class="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        [attr.aria-valuenow]="progressPercent"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        [style.width]="progressPercent + '%'"
                      >
                        {{ progressPercent }}%
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="container.type == 1 && !templateUrl"
            class="form-group row align-items-center"
          >
            <label class="control-label col-sm-3" for="IsDraftMode"
              >Draft Mode</label
            >
            <div class="col-sm-9">
              <div class="btn-group btn__sm">
                <label class="switch">
                  <input
                    type="checkbox"
                    [checked]="container.isDraftMode"
                    (change)="container.isDraftMode = !container.isDraftMode"
                  />
                  <span class="slider vPlaybookActiveToggle round"></span>
                </label>
              </div>
            </div>
          </div>

          <div
            class="form-group row mb-2"
            *ngIf="container.parentContainerId == null && container.type == 1"
          >
            <label class="control-label col-sm-3 pt-0">Custom Page Icon</label>
            <div class="upload-image col-sm-8">
              <a
                class="remove-placeholder-image"
                (click)="removeImage(false)"
                *ngIf="container.customIconAssetId"
              >
                <i class="material-icons pointer" aria-hidden="true">delete</i>
              </a>
              <div (click)="openFileDialog(false)" class="upload-image-file">
                <div
                  *ngIf="
                    !uploadedIconImg && !container.customIconAssetId;
                    else imgselected
                  "
                  class="upload-box pointer"
                  title="click to change file"
                >
                  <span class="material-icons upload-icon upload-icon-color"
                    >cloud_upload</span
                  >
                </div>
                <ng-template #imgselected>
                  <img
                    id="imgBackground"
                    title="click to change file"
                    class="upload-box uploaded-image pointer"
                    [ngStyle]="{
                      width:
                        uploadedIconImg || container.customIconAssetId
                          ? 'auto'
                          : '100%',
                      height: uploadedIconImg ? '24px' : '115px',
                      margin: uploadedIconImg ? '15px' : '0'
                    }"
                    [src]="getIconImageSrc() | loadSecureAssets : true | async"
                    alt=""
                    onerror="this.src = 'assets/img/loader.gif'"
                    (load)="imageLoadedImg = true"
                    [hidden]="!imageLoadedImg"
                  />
                </ng-template>
                <div class="file-upload hide">
                  <input
                    id="customIconImage"
                    #fileInputIcon
                    (click)="fileInputIcon.value = null"
                    (change)="imageSelected($event, false)"
                    accept="image/jpg, image/jpeg, image/png"
                    class="file-upload__input"
                    type="file"
                    name="preview-file-upload"
                  />
                </div>
                <div id="transparent-uploadifive-queue"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <span [ngSwitch]="container.type" *ngIf="languageId === defaultLanguageId">
      <span *ngSwitchCase="1">
        <button
          type="button"
          *ngIf="verb == 'Add' && copiedItem.exists"
          class="btn vPlaybookDefaultButton btn__btn-default"
          data-bs-dismiss="modal"
          (click)="onPasteCurrentPage()"
        >
          Paste Copied Page
        </button>
        <button
          type="button"
          *ngIf="verb == 'Edit'"
          class="btn vPlaybookDefaultButton btn__btn-default"
          data-bs-dismiss="modal"
          (click)="copyCurrentPage()"
        >
          Copy Page
        </button>
      </span>
      <span *ngSwitchDefault>
        <button
          type="button"
          *ngIf="verb == 'Add' && copiedItem.exists"
          class="btn vPlaybookDefaultButton btn__btn-default"
          data-bs-dismiss="modal"
          (click)="onPasteCopiedSection()"
        >
          Paste Copied Section
        </button>
        <button
          type="button"
          *ngIf="verb == 'Edit'"
          class="btn vPlaybookDefaultButton btn__btn-default"
          data-bs-dismiss="modal"
          (click)="copyCurrentSection()"
        >
          Copy Section
        </button>
      </span>
    </span>
    <button
      *ngIf="container.id > 0 && languageId === defaultLanguageId"
      type="button"
      class="btn vPlaybookDefaultButton btn__btn-default"
      data-bs-dismiss="modal"
      (click)="deleteContainer()"
    >
      <i class="material-icons delete-btn" aria-hidden="true">delete</i>Delete
    </button>
    <button
      type="button"
      class="btn vPlaybookDefaultButton btn__btn-default"
      data-bs-dismiss="modal"
      (click)="closeAddPageModal()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn__btn-default btn__orange"
      [disabled]="addEditPageForm.invalid || isSubmit"
      [ngClass]="{ 'custom-btn-disabled': addEditPageForm.invalid }"
      (click)="addEditPage()"
    >
      Save
    </button>
  </div>
</div>
